import { Maybe } from '@graphql-tools/utils'
import { AppFeatures } from '@/experimentation'
import { GuildSale } from '@/services/SaleService'

/**
 * This is checking to see if the currently active Sale is the Black Friday sale configured in Contentful here
 * https://app.contentful.com/spaces/4jbwlym6m4be/environments/master/entries/2POg7wu58Fd6Wo3hxByhna?focusedField=name&focusedLocale=en
 * @param sale
 * @param experiments
 */
export const isDavidTicketsOfferedWithAnnualPlans = (
  sale: Maybe<GuildSale>,
  experiments: Record<keyof AppFeatures, unknown>,
) => {
  return sale?.id === '2POg7wu58Fd6Wo3hxByhna' || experiments['david-tickets-annual-plans'] === true
}
